"use client";

import { create } from "zustand";

interface SelectedGuess {
    guessNo: string;
    betType: 1 | 2;
}

interface SelectedGuessCacheState {
    currentEventNo: string | null;
    selectedGuess: SelectedGuess | null;
    updateSelectedGuess: ( eventNo: string, guessNo: string, betType: 1 | 2 ) => void;
    clearCache: () => void;
    getSelectedGuess: ( eventNo: string ) => SelectedGuess | null;
}

export const useSelectedGuessCache = create<SelectedGuessCacheState>( ( set, get ) => ( {
    currentEventNo: null,
    selectedGuess: null,
    updateSelectedGuess: ( eventNo: string, guessNo: string, betType: 1 | 2 ) => {
        set( {
            currentEventNo: eventNo,
            selectedGuess: { guessNo, betType },
        } );
    },
    clearCache: () => {
        set( {
            currentEventNo: null,
            selectedGuess: null,
        } );
    },
    getSelectedGuess: ( eventNo: string ) => {
        const state = get();
        if ( state.currentEventNo === eventNo && state.selectedGuess ) {
            return state.selectedGuess;
        }
        return null;
    },
} ) );
